import React from 'react';
import { ThumbsUp, ThumbsDown } from 'lucide-react';
import { MessageModel } from '../../../_metronic/helpers';

interface FeedbackButtonsProps {
  message: MessageModel;
  index: number;
  onRate: (message: MessageModel, index: number, value: string) => void;
}

const FeedbackButtons: React.FC<FeedbackButtonsProps> = ({ message, index, onRate }) => (
  <div className="flex items-center gap-1.5 mt-1">
    <button
      onClick={() => onRate(message, index, 'yes')}
      className={`p-1.5 rounded-lg transition-all duration-200 ${
        message.rating === 'yes'
          ? 'bg-green-100 text-green-600 scale-110'
          : 'hover:bg-gray-100 text-gray-400 hover:text-gray-600'
      }`}
      title="Resposta boa"
      aria-label="Marcar como resposta boa"
    >
      <ThumbsUp className="w-4 h-4" />
    </button>
    <button
      onClick={() => onRate(message, index, 'no')}
      className={`p-1.5 rounded-lg transition-all duration-200 ${
        message.rating === 'no'
          ? 'bg-red-100 text-red-600 scale-110'
          : 'hover:bg-gray-100 text-gray-400 hover:text-gray-600'
      }`}
      title="Resposta ruim"
      aria-label="Marcar como resposta ruim"
    >
      <ThumbsDown className="w-4 h-4" />
    </button>
  </div>
);

export default FeedbackButtons;
